import Immutable from 'immutable';
import {
  COMPANY_RESOURCE_GROUP_PATH,
  COMPANY_RESOURCE_PATH,
  HOME_PATH,
  PREVENTIVE_TASK_ASSIGNEE_PATH,
  PREVENTIVE_TASK_EXECUTION_PATH,
  PREVENTIVE_TASK_PATH,
  PREVENTIVE_TASK_PROJECTION_PATH,
  TASK_SCHEDULE_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      id: 'company-resource',
      title: 'Recursos de la Compañia',
      path: COMPANY_RESOURCE_PATH,
      icon: 'building',
    },
    {
      id: 'company-resource-group',
      title: 'Grupo de Recursos de la Compañia',
      path: COMPANY_RESOURCE_GROUP_PATH,
      icon: 'object-group',
    },
    {
      id: 'preventive-task',
      title: 'Tareas Programadas',
      path: PREVENTIVE_TASK_PATH,
      icon: 'tasks',
    },
    {
      id: 'preventive-task-assignee',
      title: 'Asignación de Tareas Programadas',
      path: PREVENTIVE_TASK_ASSIGNEE_PATH,
      icon: 'user-plus',
    },
    {
      id: 'preventive-task-execution',
      title: 'Ejecución de Tarea Programadas',
      path: PREVENTIVE_TASK_EXECUTION_PATH,
      icon: 'calendar-check-o',
    },
    {
      id: 'preventive-task-projection',
      title: 'Proyección de Tarea Programadas',
      path: PREVENTIVE_TASK_PROJECTION_PATH,
      icon: 'calendar-o',
    },
  ],
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
    {
      text: 'Tarea Programadas',
      tag: 'span',
      href: TASK_SCHEDULE_PATH,
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
